var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBasketDark = function SvgBasketDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.007 12.011c.03-.719-.31-2.031-1.44-2H6.727l-.81-2.806a1.6 1.6 0 0 0-1.43-1.194h-2.47a.879.879 0 0 0-1.01.981v.193a.956.956 0 0 0 1.19.887h.89l1.76 6.276a2.174 2.174 0 0 0 2.16 1.663h9a2.155 2.155 0 0 0 2-1l1-3zm-12.99 10.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm7 0a1.49 1.49 0 1 0 1.49-1.5 1.5 1.5 0 0 0-1.49 1.5z",
    stroke: "#000",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  })));
};
export default SvgBasketDark;